module.exports = __webpack_public_path__ + "img/trash_filled_64.bffe7ab9.svg";